const size = {
  // 1rem = 41.61px
  mobile: "576px", // 425px
  tablet: "48em", // 768px
  laptop: "64em", // 1024px
  laptopL: "90em", // 1440px
  desktop: "160em" // 2560px
}

export const device = {
  mobile: `(min-width: ${size.mobile})`,
  tablet: `(min-width: ${size.tablet})`,
  laptop: `(min-width: ${size.laptop})`,
  laptopL: `(min-width: ${size.laptopL})`,
  desktop: `(min-width: ${size.desktop})`
}



// WEBPACK FOOTER //
// ./src/media.js